import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';

import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const BusBookingFlow = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusBookingFlow" */ '../containers/BusBookingFlowContainer'),
  loading: DefaultLoadingScreen,
});

class BusBookingFlowScreen extends React.Component {
  static navigationOptions = ({ navigation }) => ({
    headerTitle: <HeaderOneLine title="Kursi dan Data Penumpang" />,
  });

  render() {
    return (
      <BusBookingFlow
        {...this.props}
        id={this.props.navigation.getParam('id', '')}
      />
    );
  }
}

export default BusBookingFlowScreen;
